import { PlanDetailGroupOrder, PlanDetailRowsOrder } from '../PlanDetails.Types';
import { PlanDetailEntry } from 'components/PlanData/Types/GetPlanDetailsResponse.Type';

export const sortPlanDetailRowEntries = (
  rows: PlanDetailEntry[],
  planDetailRowsOrder: PlanDetailRowsOrder[]
): PlanDetailEntry[] => {
  if (planDetailRowsOrder?.length === 0) {
    return rows;
  }

  return rows.slice().sort((a, b) => {
    const idA = a.entryRow.id;
    const idB = b.entryRow.id;

    const indexA = planDetailRowsOrder?.findIndex((item) => item.id === idA) || 0;
    const indexB = planDetailRowsOrder?.findIndex((item) => item.id === idB) || 0;

    if (indexA === -1) return 1;
    if (indexB === -1) return -1;

    return indexA - indexB;
  });
};

export const sortPlanDetailEntries = (
  planDetailEntries: PlanDetailEntry[],
  planDetailGroupEntryOrder: PlanDetailGroupOrder[]
): PlanDetailEntry[] => {
  if (planDetailGroupEntryOrder?.length === 0) {
    return planDetailEntries;
  }

  return planDetailEntries.slice().sort((a, b) => {
    const captionA = a.entryRow.entryTable.caption.value;
    const captionB = b.entryRow.entryTable.caption.value;

    const indexA = planDetailGroupEntryOrder.findIndex((item) => item.caption === captionA);
    const indexB = planDetailGroupEntryOrder.findIndex((item) => item.caption === captionB);

    // If the caption is not found in the planDetailGroupEntryOrder, it's pushed to the end
    if (indexA === -1) return 1;
    if (indexB === -1) return -1;

    return indexA - indexB;
  });
};
